import { render, staticRenderFns } from "./offerwall-info.vue?vue&type=template&id=1467c662&scoped=true&"
import script from "./offerwall-info.vue?vue&type=script&lang=js&"
export * from "./offerwall-info.vue?vue&type=script&lang=js&"
import style0 from "./offerwall-info.vue?vue&type=style&index=0&id=1467c662&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1467c662",
  null
  
)

export default component.exports